
export const mm = 1;
export const inches = 25.4; // mm per inch

export const lineBlueHeavy = 0x15314E;
export const lineBlueLight = 0x2563B8;
export const lineBlueGrey = 0xD6E2F2;
export const lineGreenGrey = 0xD6F2DC;

// neutral grey fill for fixed (solid metal) panels. Kept at a similar lightness
// to the glass wash so it stays subtle on the drawing, but with the blue cast
// removed so it reads as metal and is easy to tell apart from a glass lite.
export const panelMetalGrey = 0xDEDFE1;

// warm tan fill for wood fixed panels, at the same lightness as the metal grey so
// the two read as materials rather than as emphasis.
export const panelWoodTan = 0xE9DCC4;

export const lineRed = 0xE57373;

// the prep layer (hole + offset dimensions for the 161 / DB preps, the closer band):
// deep yellow-orange, and a darker orange once the user has moved a prep off its
// standard spot. The band is shaded: a wash of the line color plus a diagonal hatch.
export const linePrepYellow = 0xE8A000;
export const linePrepYellowUser = 0xC46A00;
export const prepBandAlpha = 0.3;
export const lineRedGrey = 0xF8D7DA;

export const backgroundBlue = 0xF4F8FD;

export const gridBlue0 = 0xD6E2F2;
export const gridBlue1 = 0xE9F0FA;

